var _ellipse, _ellipse2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileMenuBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 146,
    viewBox: "0 0 261 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.6466,
    cy: 129.306,
    rx: 44.4716,
    ry: 44.6466,
    transform: "rotate(-90 44.6466 129.306)",
    fill: "#FF5F45"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.516,
    cy: 75.6887,
    rx: 75.6902,
    ry: 74.8868,
    transform: "rotate(-90 183.516 75.6887)",
    fill: "#00252D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 231.996,
    width: 124,
    height: 109,
    transform: "rotate(-90 198 231.996)",
    fill: "#FFA540"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuBg);
export default __webpack_public_path__ + "static/media/mobile_menu_bg.5cf287cb05e5c14f60d5d60ec5b85f75.svg";
export { ForwardRef as ReactComponent };